{
	"breakdown": {
		"title": "The calculation, step by step"
	},
	"config": {
		"effect_notice": "Changes take effect from the next proposals: already generated documents do not change.",
		"example_label": "Example",
		"history_entry": "Configurazione salvata",
		"history_load_more": "Load more",
		"history_system": "Automatic change",
		"history_title": "Change history",
		"no_changes": "No changes to save",
		"page_title": "Configuration",
		"remove": "Remove",
		"safety_default": "Standard safety stock",
		"safety_description": "How much extra stock to order beyond the forecast. More stock = less risk of running out, more unsold.",
		"safety_esclusiva": "Safety stock for exclusives",
		"safety_example": "",
		"safety_title": "Safety stock",
		"save": "Save configuration",
		"sections_label": "Configuration sections",
		"tuning": {
			"adoptionBookingCap": "Maximum projection of booked demand (0 = off)",
			"adoptionBookingMin": "Minimum booked copies to project",
			"adoptionCellPrior": "Caution on thin data (sections)",
			"adoptionRegionWeighting": "Value sections zone by zone",
			"adoptionWeightMax": "Maximum deviation allowed from the average",
			"adoptionWeightMin": "Minimum deviation allowed from the average",
			"adoption_description": "How the sections adopting a title become copies to order. There is no single number: from one adopting section Mantegna absorbs 6.6 copies in Lazio and 0.66 in Campania, and within the same region it changes from publisher to publisher (Zanichelli in Campania 0.20, Petrini 3.44). The engine therefore sums the sections region by region, each at its real value for that publisher and school level — the same calculation you do in your head knowing where you actually sell. «Caution» keeps a region/publisher pair with very few adoptions from standing on its own: below that many sections of history, the region average counts too. The two limits are a safety net for extremes.",
			"adoption_example": "A title with 226 sections in Lazio and 572 in Campania is not worth 798 × the national average, but 226 × 9.43 plus 572 × 3.61.",
			"adoption_title": "School adoptions",
			"adottatoHistoryThreshold": "Max own sales for adoption",
			"age": "Age {{n}}",
			"blendK": "Blend weight k",
			"blendMinElapsed": "Minimum season elapsed",
			"blend_description": "How the current season corrects the forecast.",
			"blend_example": "",
			"blend_title": "In-season blend",
			"campaignAnticipoShare": "Campaign anticipation share (0-1)",
			"coexistMinYearGap": "Minimum years between two editions to flag a duplicate (0 = off)",
			"edizioneRecenteMaxAge": "Maximum age",
			"edizioneRecenteMinVol": "Minimum sales",
			"fitMinBase": "Minimum sales for fits",
			"leadTimeDays": "Supplier delivery days",
			"lotExactBelow": "Below this quantity stays exact",
			"lotMinRecurring": "Minimum recurring lot",
			"lot_add_step": "Add step",
			"lot_description": "How quantities are rounded to order lots.",
			"lot_example": "",
			"lot_step_final": "above",
			"lot_step_step": "Step",
			"lot_step_upto": "Up to",
			"lot_steps_label": "Rounding steps",
			"lot_title": "Lot rounding",
			"recent_description": "When a title is flagged as a recent edition.",
			"recent_example": "",
			"recent_title": "Recent edition",
			"regimes_description": "How the two document types differ. A «campaign» document anticipates the season: it proposes the given share of the residual annual demand (1 = the whole year at once, 0.5 = half now and the rest via reorders). A «reorder» document covers the next days of seasonal demand (the period is chosen at creation; this value applies when omitted) PLUS the supplier delivery days: if goods take 10 days to arrive, today’s order must also cover that wait. It always covers copies customers already asked for (open orders, backorders, bookings). Orders placed with suppliers show up as Mr.Book loads at the next sync.",
			"regimes_example": "In late July a 14-day reorder covers the start of the August peak; the same in February would propose almost zero.",
			"regimes_title": "Campaign and reorders",
			"reorderHorizonDays": "Days covered by one reorder",
			"retCeil": "Maximum retention",
			"retFloor": "Minimum retention",
			"retMature": "Mature-edition retention",
			"retention_description": "Share of sales kept as the edition ages.",
			"retention_example": "",
			"retention_title": "Retention curve",
			"scorrimentoMaxOwn": "Max own sales for progression",
			"scorrimentoRecoverMin": "Predecessor sales to recover",
			"segClipHigh": "Maximum multiplier",
			"segClipLow": "Minimum multiplier",
			"segMinVol": "Minimum segment volume",
			"segment_description": "Retention correction per Mr.Book sector, i.e. publishing group or distributor.",
			"segment_example": "",
			"segment_title": "Sector multiplier (publishing group)",
			"succActiveMin": "Minimum candidate sales",
			"succCollapseRatio": "Collapse ratio",
			"succDeclineFromMin": "Minimum historical sales",
			"succSimMin": "Minimum title similarity",
			"succession_description": "When a title is considered replaced by a new edition.",
			"succession_example": "",
			"succession_title": "New-edition detection",
			"universe_description": "Which titles enter the list and how new ones are recovered.",
			"universe_example": "",
			"universe_title": "Universe threshold & recovery",
			"ytdFloorCap": "Max uplift on already-sold copies (0 = off)",
			"reorderNewTitleShare": "Season share for new adopted titles (0-1)",
			"exclusivityFactorMin": "Minimum factor for a lost exclusivity (0-1, 0.1 = down to −90%)",
			"exclusivityFactorMax": "Maximum factor for a gained exclusivity (3 = up to ×3)"
		},
		"unsaved": "Unsaved changes"
	},
	"correct": {
		"confirm": "Save correction",
		"from": "Current",
		"note_help": "Explain why you are correcting the proposal. Notes are collected as feedback and used to improve the algorithm that generates order proposals.",
		"note_label": "Notes (required)",
		"note_placeholder": "E.g. adoption not confirmed, ordering fewer…",
		"quick": {
			"adozione": "Adoption not confirmed",
			"capo_ciclo": "Cycle head: waiting for adoption",
			"cappottato": "Title changed by publisher",
			"gia_coperto": "Already covered by bookings",
			"non_uscito": "Book not released yet",
			"zona": "Not my area"
		},
		"same_as_proposal": "La correzione deve essere diversa dalla quantità proposta.",
		"system_proposal": "System’s original proposal: {{qty}}",
		"title": "Confirm correction",
		"to": "New",
		"too_large": "The quantity exceeds the allowed maximum ({{max}}): did you paste a code?"
	},
	"dashboard": {
		"agent": "Mr.Book connection",
		"agent_full_label": "Last complete update",
		"agent_name_label": "Agent",
		"agent_seen_label": "Last contact",
		"current_campaign": "Campaign {{year}}",
		"data_freshness": "Data freshness",
		"never": "never",
		"no_agent_hint": "The sync program is not installed on the Mr.Book PC yet.",
		"no_run_hint": "Quando i dati saranno arrivati, potrai generare il primo documento dalla sezione Documenti PO.",
		"no_run_yet": "Nessun documento generato finora",
		"open_document": "Open the document",
		"refresh_now": "Refresh data now",
		"run_failed": "La generazione di questo documento è fallita. Apri il documento per i dettagli.",
		"stale_warning": "Warning: you are looking at data from {{days}} days ago. The system stays usable, but quantities may not reflect the latest sales.",
		"trust_fresh": "Data current as of {{date}}: the next document will use it.",
		"waiting_first_data": "We are waiting for the first data from Mr.Book: it arrives by itself at noon and midnight.",
		"stale_close": "Dismiss notice",
		"refresh_syncing": "Syncing",
		"refresh_done": "Data refreshed",
		"refresh_stalled": "The agent did not answer the last request",
		"dataset_label": "Mr.Book data as of",
		"sync_in_progress": "Update in progress",
		"tables_heading": "Tables the documents use",
		"confirmed_heading": "Verified on",
		"newer_version_pending": "Newer version on its way",
		"newer_version_pending_hint": "A newer version of this table has already arrived: documents will use it once the update is done.",
		"table_stale_hint": "This table has not been verified for more than a day.",
		"refresh_incomplete": "Update failed",
		"refresh_incomplete_tables": "Update failed for: {{list}}",
		"table_failed": "Last update failed: {{reason}}",
		"table_failed_no_reason": "Last update failed",
		"table_behind": "Not updated with the other tables: documents use it as it was at this date."
	},
	"accept": {
		"cancel": "Cancel",
		"view_button": "Accept this view ({{rows}})",
		"whole_button": "Accept all ({{rows}})",
		"confirm_one": "Yes, accept the row",
		"confirm_other": "Yes, accept {{rows}} rows",
		"confirm_view_title_one": "Accept the row in this view?",
		"confirm_view_title_other": "Accept the {{rows}} rows of this view?",
		"confirm_whole_title_one": "Accept the last row to review?",
		"confirm_whole_title_other": "Accept all {{rows}} rows to review?",
		"confirm_whole_description_one": "The last row still to review will be accepted, even if flagged. The action is audited.",
		"confirm_whole_description_other": "All {{rows}} rows still to review will be accepted, including flagged ones. The action is audited.",
		"confirm_view_description_one": "The other row of the document is not touched. Corrected rows don’t change and the action is audited.",
		"confirm_view_description_other": "The other {{others}} rows of the document are not touched. Corrected rows don’t change and the action is audited."
	},
	"detail": {
		"accept": "Accept the proposal",
		"close": "Close the detail",
		"correct_label": "Quantity to order",
		"correct_submit": "Correct",
		"decision": "Your decision",
		"history_empty": "No decision on this row yet.",
		"adoption_regions": "Adoptions by region",
		"adoption_regions_hint": "Where the sections that adopted the title are. Region weighting raises or lowers the estimate by how strong Mantegna is in those regions.",
		"copies_proposed": "proposed copies",
		"corrected_to": "your correction",
		"history": "History of this row",
		"past_campaigns": "Past campaigns on this title",
		"past_decision": "proposed {{proposed}} → decided {{decided}}",
		"past_not_reviewed": "proposed {{proposed}} · not reviewed",
		"reasoning": "Why this number"
	},
	"detail_breadcrumb": "Document",
	"detail_page": {
		"adottato_missing": "This year's adoption data was not loaded when this document was generated: the adoption contribution is not included.",
		"failed_title": "Generation failed",
		"failed_unknown": "Unknown error",
		"generating": "Generating the proposals: the document will refresh by itself in a moment.",
		"generating_title": "Generating the document",
		"signals_missing": "This document is missing Mr.Book data: {{list}}. The engine read it as zero or estimated it: quantities may be wrong.",
		"simulation_banner": "This is an empty-warehouse SIMULATION document: stocks were zeroed to validate the reasoning. Do not use it as a real order."
	},
	"export": {
		"active_filters": "Active filters",
		"description": "The file reflects the reviews done so far, corrections included, and contains only the rows the active filters below let through.",
		"disabled_simulation": "Empty-warehouse simulations cannot be exported: generate a normal document.",
		"failed": "The export failed: try again in a few minutes.",
		"filter_distributor": "Distributor",
		"filter_publisher": "Publisher",
		"filter_review": "Review",
		"filter_school_type": "School type",
		"filter_search": "Search",
		"generate": "Generate the export",
		"generating": "Generating…",
		"no_filters": "No active filters: the export contains the whole document.",
		"ready": "Export ready: the download starts by itself",
		"remove_filter": "Remove the {{filter}} filter",
		"still_generating": "The export is being generated: you will find it in the document's export history tab shortly",
		"title": "Export orders"
	},
	"exports": {
		"all_statuses": "Tutti gli stati",
		"columns": {
			"actions": "Actions",
			"document": "Document",
			"generated_at": "Generated on",
			"id": "ID",
			"status": "Status",
			"summary": "Contents"
		},
		"completed": "Ready",
		"download_csv": "Download CSV",
		"download_xlsx": "Download Excel",
		"empty_description": "Exports are generated from the proposal document.",
		"empty_document_description": "You have not generated any export from this document yet.",
		"empty_title": "No exports",
		"failed": "Failed",
		"pending": "Generating",
		"summary_line": "{{titles}} titles · {{copies}} copies · {{publishers}} publishers"
	},
	"grid": {
		"accept_short": "Accept",
		"adoptions_title": "Sections adopting the title: last campaign and the current one. The trend is the signal — a collapse announces an edition change. Click the figure for the regions.",
		"all_distributors": "All distributors",
		"all_publishers": "All publishers",
		"all_reviews": "Tutti gli stati",
		"all_school_types": "All types",
		"available_title": "Sellable stock now: on-hand minus reserved copies (Pren.Disp + picking list). Matches Mr.Book's Disponibilità",
		"bulk_accept": "Accept {{count}} rows",
		"columns": {
			"adoptions": "Adoptions",
			"code": "ISBN",
			"corrected": "Corrected",
			"note": "Notes",
			"pred_sold": "Prev. volume sold",
			"proposed": "Proposed",
			"school_type": "Type",
			"sold_history": "Sold",
			"status": "Stato",
			"stock": "Available",
			"stock_real": "On hand",
			"title": "Title"
		},
		"copied": "Copied!",
		"empty_description": "No rows match the selected filters.",
		"empty_title": "No results",
		"no_predecessor": "No previous volume",
		"not_bulk_selectable": "Row already reviewed: no need to re-accept it.",
		"pred_sold_title": "The previous volume's sales over the last 3 years (the grade before this one): the base for judging a scorrimento.",
		"search_placeholder": "Search by title, ISBN or code…",
		"sold_history_title": "Copies sold over the last 3 years, oldest to newest — the same counters as the Mr.Book card's history box. The column sorts by the most recent year.",
		"stock_title": "Real stock on hand: start-of-year existence plus loads, minus this year’s sales and returns",
		"bulk_accepted_one": "1 row accepted",
		"bulk_accepted_other": "{{count}} rows accepted",
		"mrbook_code": "code {{code}}"
	},
	"history": {
		"bulk_accepted": "Accepted (bulk)",
		"proposal_accepted": "Accepted",
		"proposal_corrected": "Quantity corrected",
		"proposal_feedback": "Note added"
	},
	"index": {
		"all_statuses": "Tutti gli stati",
		"columns": {
			"campaign": "Campaign",
			"created_at": "Created",
			"id": "ID",
			"name": "Name",
			"review_progress": "Review",
			"status": "Status",
			"updated_at": "Last modified",
			"updated_at_hint": "The latest work on the document: its generation, decisions on its rows, its name or its status. The list's default order, most recent first."
		},
		"distributors_all": "All distributors",
		"distributors_clear_all": "Deselect all",
		"distributors_no_match": "No distributor matches the search.",
		"distributors_search_placeholder": "Search a distributor…",
		"distributors_select_all": "Select all",
		"distributors_selected_count": "{{count}} selected",
		"distributors_title": "Distributors",
		"empty_description": "Generate your first purchase proposal to get started.",
		"empty_title": "No documents",
		"generate_document": "Generate the document",
		"generation_started": "Generation started: the document will refresh by itself",
		"horizon_biweekly": "Every two weeks",
		"horizon_daily": "Every day",
		"horizon_monthly": "Every month",
		"horizon_weekly": "Every week",
		"mode_campagna": "Campaign",
		"mode_campagna_hint": "The plan for the whole season: the residual year's demand, to review title by title and order in tranches.",
		"mode_riordino": "Reorder",
		"new_document": "New document",
		"new_document_explainer": "The document is built from the Mr.Book data and must be reviewed title by title.",
		"reorder_group": "How often you place orders",
		"reorder_note": "Covers the period's sales plus the {{lead}} delivery days, and the copies owed to customers: you are covered until {{date}}.",
		"reviewed_of": "{{reviewed}} / {{total}}",
		"search_placeholder": "Search by name…",
		"simulation_hint": "Every stock read as zero, document not exportable.",
		"simulation_label": "Empty-warehouse simulation",
		"dataset_as_of": "The document will use the Mr.Book data as of {{date}}.",
		"dataset_syncing": "Update in progress: the document will use the data as of {{date}}. If you need the new data, wait for the update to finish.",
		"dataset_unavailable": "The date of the Mr.Book data cannot be read right now: the document will still use the last complete update.",
		"no_complete_dataset": "There is no complete Mr.Book data yet, so the document cannot be generated. Press «Refresh data now» on the Dashboard and try again once the update is done.",
		"no_complete_dataset_syncing": "There is no complete Mr.Book data yet: you can generate the document once the update in progress is done.",
		"dataset_date": "The document will use the Mr.Book data of {{date}}.",
		"tables_behind_effect": "Quantities may not reflect what changed in Mr.Book since then.",
		"update_failed": "The last update failed for: {{list}}. The document will use the data received before.",
		"dataset_not_ready": "Some essential Mr.Book data is missing: the document cannot be generated until it arrives."
	},
	"page_title": "PO documents",
	"rename": {
		"save": "Save the name",
		"saved": "Name updated",
		"title": "Rename"
	},
	"review": {
		"accepted": "Accepted",
		"corrected": "Corrected",
		"pending": "Da rivedere"
	},
	"school_type": {
		"elementari": "Primary",
		"medie": "Middle",
		"superiori": "High school",
		"varia": "Trade"
	},
	"status": {
		"archived": "Archived",
		"completed": "Completed",
		"failed": "Failed",
		"in_progress": "In progress",
		"pending": "Queued",
		"running": "Generating"
	},
	"tabs": {
		"exports": "Export history",
		"proposals": "Proposals"
	},
	"workflow": {
		"archive": "Archive",
		"archive_confirm": "Archive the document",
		"archive_confirm_description": "The document leaves the current work and stays readable. It can no longer be restored.",
		"archive_confirm_description_wip": "The document is still in progress: archiving freezes the proposals as they are and it can never be picked back up or completed. To work on it again you will have to generate a new document.",
		"archive_confirm_title": "Archive this document?",
		"cancel": "Cancel",
		"complete": "Complete document",
		"complete_blocked": "{{count}} rows still need reviewing before the document can be completed.",
		"complete_confirm": "Complete the document",
		"complete_confirm_description": "The document stays readable and exportable, but its rows can no longer be edited and it cannot be reopened. To work on it again you will have to generate a new document.",
		"complete_confirm_title": "Complete this document?",
		"moved_to_archived": "Document archived",
		"moved_to_completed": "Document completed",
		"transition_refused": "The document had already changed, perhaps in another tab: you now see its current status."
	},
	"workspace": {
		"copies": "Proposed copies",
		"flagged": "Flagged",
		"progress": "Review",
		"to_review_inline": "{{n}} to review",
		"to_review": "To review",
		"universe": "Titles",
		"dataset_as_of": "Mr.Book data as of {{date}}",
		"dataset_as_of_hint": "The document was generated on this data: an update that arrived later does not change it.",
		"table_behind": "{{table}} data stuck at {{date}}",
		"table_behind_hint": "This table did not arrive with the update the document used: quantities may not reflect what changed in Mr.Book afterwards."
	},
	"calc": {
		"hide_basis": "Hide the provenance",
		"show_basis": "Where these numbers come from"
	},
	"dataset": {
		"missing_required": "Mr.Book data every document needs is missing: {{list}}. Documents cannot be generated until it arrives.",
		"table_behind": "{{table}} data is stuck at {{date}}.",
		"unresolved": "The data of {{list}} must be sent again by Mr.Book: ask support for a complete update. Until it arrives, documents do not use it."
	}
}
